import classNames from "classnames/bind";
import { Swiper, SwiperProps, SwiperSlide } from "swiper/react";
import { FreeMode, Grid, Navigation } from "swiper/modules";
import styles from "./CarouselSwiper.module.scss";

const cx = classNames.bind(styles);

export interface CarouselSwiperProps extends SwiperProps {
    id: string;
    isFading?: boolean;
}

const CarouselSwiper = (props: CarouselSwiperProps) => {
    const {
        children,
        id,
        slidesPerView = "auto",
        spaceBetween = 20,
        modules = [Navigation, FreeMode, Grid],
        navigation = {
            nextEl: `#${"nextButton" + id}`,
            prevEl: `#${"prevButton" + id}`,
        },
        className,
        freeMode = true,
        isFading = false,
        ...rest
    } = props;

    const attrs = {
        ...rest,
        id,
        slidesPerView,
        spaceBetween,
        freeMode,
        modules,
        navigation,
        className: cx({ fading: isFading }, className),
    };
    return (
        <div className={cx("container", className)}>
            <Swiper {...attrs}>
                {Array.isArray(children) ? (
                    children.map((elem, i) => <SwiperSlide key={i}>{elem}</SwiperSlide>)
                ) : (
                    <SwiperSlide className={cx("slide")}>{children}</SwiperSlide>
                )}
            </Swiper>
        </div>
    );
};

export default CarouselSwiper;
